import { Location } from '@angular/common';
import { isNullOrUndefined } from '@swimlane/ngx-datatable';
import { StatusTrackerKeys } from '../../Models/configuration';
import { CultureLocaleService } from '../../Services/culture/culture-locale.service';
import { GlobalService } from './global.service';
import { SecureStorage } from './secure-storage';

export function InitApp(location: Location, gservce: GlobalService, cultureLocaleService: CultureLocaleService, secureStorage: SecureStorage) {

  let perms = window.location.href.split('?')[1]; // further change
  if ((window.location.href.split("?").length - 1) === 2) {
    let langCode = window.location.href.split('?')[2];
    gservce.customerDefaultLanguage = langCode;
  } else if ((window.location.href.split("?").length - 1) === 3) {
    // task - 8584 - bypass validation input if number plate is in route
    let langCode = window.location.href.split('?')[2];
    gservce.customerDefaultLanguage = langCode;
    let autoLpNumber = window.location.href.split('?')[3];
    secureStorage.setKeyData(StatusTrackerKeys.autoCarPlate, autoLpNumber);
  }
  if (isNullOrUndefined(perms)) {
    let storageData = gservce.getAppInitialData?.AppointmentGuid ?? '';
    if (storageData != '') {
      if (location.path() == '/authenticate') {
        secureStorage.removeKey(StatusTrackerKeys.tinyUrl);
      }
      location.go(location.path());
    } else {
      let storageUrl = secureStorage.getKeyData(StatusTrackerKeys.tinyUrl);
      if (isNullOrUndefined(storageUrl)) {
        location.go(`/error-page`);
      } else {
        secureStorage.removeKey(StatusTrackerKeys.tinyUrl);
        location.go(`/authenticate`);
      }
    }
  } else {
    secureStorage.removeKey(StatusTrackerKeys.tinyUrl);
    secureStorage.setKeyData(StatusTrackerKeys.tinyUrl, perms);
    location.go(`/authenticate`);
  }
  return async () => {
    await cultureLocaleService.initialise();
  }
}
